import { render, staticRenderFns } from "./InvestorContactData.vue?vue&type=template&id=0f15edae&scoped=true&"
import script from "./InvestorContactData.vue?vue&type=script&lang=js&"
export * from "./InvestorContactData.vue?vue&type=script&lang=js&"
import style0 from "./InvestorContactData.vue?vue&type=style&index=0&id=0f15edae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f15edae",
  null
  
)

export default component.exports